import { render, staticRenderFns } from "./WhyECommerce.vue?vue&type=template&id=6d7b39f9&"
import script from "./WhyECommerce.vue?vue&type=script&lang=js&"
export * from "./WhyECommerce.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports